var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDashBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3155_46425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15V12.5",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 16.0334C17 17.2084 15.8583 18.175 14.6667 18.175H5.33333C4.13333 18.175 3 17.2167 2.8 16.0334L1.69167 9.40004C1.55 8.58337 1.96667 7.4917 2.61667 6.97504L8.39167 2.35004C9.275 1.6417 10.7167 1.6417 11.6083 2.35837L17.3833 6.97504C18.025 7.4917 18.4417 8.58337 18.3083 9.40004L17.7917 12.5",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3155_46425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashBoard);
export default __webpack_public_path__ + "static/media/activeDashBoard.a3f8bc5f738beda8fa6051c9b1c18238.svg";
export { ForwardRef as ReactComponent };